//联系人
const contacts = {
  
  init: function () {
  
  },
  
  //  从联系人中提取出首字母 再排序
  sortedList: function () {
    let initialList = []
    let max = this.items.length;
    for (var i = 0; i < max; i++) {
      if (initialList.indexOf(this.items[i].initial.toUpperCase()) == -1) {
        initialList.push(this.items[i].initial.toUpperCase())
      }
    }
    return initialList.sort()
  },
  
  // 将联系人根据首字母进行分类
  groupedList: function () {
    let contactsList = {};
    let max = this.items.length;
    let items = this.sortedList()
    for (var i = 0; i < items.length; i++) {
      var protoTypeName = items[i]
      contactsList[protoTypeName] = []
      for (var j = 0; j < max; j++) {
        if (this.items[j].initial.toUpperCase() === protoTypeName) {
          contactsList[protoTypeName].push(this.items[j])
        }
      }
    }
    return contactsList
  },
  
  
  items: [{ //昵称备注都有的朋友
    "wxid": "wxid_zhaohd",
    "initial": 'z',
    "headerUrl": "https://sinacloud.net/vue-wechat/images/headers/header01.png",
    "nickname": "小手能",
    "sex": 1,
    "remark": "小手能",
    "signature": "填坑小能手",
    "telphone": 18896586152,
    "album": [{
      imgSrc: ""
    }],
    "area": ["中国", "北京", "海淀"],
    "from": "",
    "tag": "",
    "desc": {}
  },
    {
      "wxid": "wxid_baiqian",
      "initial": 'b',
      "headerUrl": "https://sinacloud.net/vue-wechat/images/headers/baiqian.jpg",
      "nickname": "小能手",
      "sex": 0,
      "remark": "",
      "signature": "小能手，小能手",
      "telphone": 18896586152,
      "album": [{
        imgSrc: "https://sinacloud.net/vue-wechat/images/album/baiqian/baiqian01.jpeg",
        date: 182625262
      }, {
        imgSrc: "https://sinacloud.net/vue-wechat/images/album/baiqian/baiqian02.jpeg",
        date: 182625262
      }],
      "area": ["青丘", "狐狸洞"],
      "from": "通过扫一扫",
      "tag": "女帝",
      "desc": {
        "title": "",
        "picUrl": ""
      }
    }
  ]
}
export default contacts;



// WEBPACK FOOTER //
// ./src/store/data/contacts.js